module.exports = __webpack_public_path__ + "static/media/04-Nürnberg@2x.46c50286.jpg";